export default {
  'en': {
    'header': 'Our <strong>amazing</strong> clients',
  },
  'da': {
    'header': 'Vores <strong>fantastiske</strong> kunder',
  }
};



// WEBPACK FOOTER //
// ./src/multilanguage/clients.js